import { render } from "./StayCase.vue?vue&type=template&id=0ff95bb7&scoped=true"
import script from "./StayCase.vue?vue&type=script&lang=ts"
export * from "./StayCase.vue?vue&type=script&lang=ts"

import "./StayCase.vue?vue&type=style&index=0&id=0ff95bb7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0ff95bb7"

export default script